import React, { useEffect, useState } from "react";
import Fields from "../Fields";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { createYupSchema } from "../../../../utilities/yupSchemaCreator";
import { useForm } from "react-hook-form";
import { useReports } from "../../Provider";
import {
  Alert,
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  Typography,
  useTheme,
} from "@mui/material";
import ErrorsList from "../../../../ui/ErrorsList";

const yupSchema = Fields.reduce(createYupSchema, {
  notes: Yup.string(),
});
const schema = Yup.object().shape(yupSchema);

const Void = ({ row, handleClose }) => {
  const [error, setError] = useState();
  const theme = useTheme();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const {
    state: { VoidReasonsList, siteIdAtt },
    fetchVoidReasonsList,
    RepayVoid,
  } = useReports();

  useEffect(() => {
    fetchVoidReasonsList(siteIdAtt);
  }, [fetchVoidReasonsList, siteIdAtt]);

  const onSubmit = async (values) => {
    try {
      await RepayVoid(row?.id, values);
      handleClose();
    } catch (error) {
      window.scroll(0, 0);
      setError({
        title: error.errors.message ? error.errors.message : "some thing wrong",
      });
    }
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Typography
        sx={{ textAlign: "center", marginRight: "10px" }}
        variant="Poster"
        component="h4"
        gutterBottom
      >
        Select a reason to void the transaction.
      </Typography>
      {error ? (
        <Alert severity="error" sx={{ my: 3 }}>
          <ErrorsList error={error} />
        </Alert>
      ) : (
        ""
      )}
      <Box>
        <FormControl
          sx={{
            mt: theme.dimensions.mt,
            mb: theme.dimensions.mb,
            width: theme.dimensions.width,
          }}
        >
          <span style={{ fontSize: "12px" }}>Reason</span>
          <Select
            sx={{
              mt: theme.dimensions.mt,
            }}
            inputProps={{
              ...register("notes"),
            }}
            size="small"
          >
            {VoidReasonsList?.map((reason, index) => (
              <MenuItem key={index} value={reason.reason}>
                {reason.reason}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box sx={{ width: theme.dimensions.width }}>
        <Button
          type="submit"
          sx={{
            background: theme.color.blackBackground,
            color: "white",
            width: "100%",
            mb: 1.3,
            "&:hover": {
              background: `${theme.color.black}`,
            },
          }}
        >
          Save
        </Button>
        <Button
          onClick={handleClose}
          sx={{
            background: theme.color.gray200,
            color: "black",
            width: "100%",
            "&:hover": {
              background: `${theme.color.gray300}`,
            },
          }}
        >
          Cancel
        </Button>
      </Box>
    </form>
  );
};

export default Void;
